import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/components/checkbox/Checkbox';
import SimpleReactValidator from 'simple-react-validator';
import { TabView, TabPanel } from 'primereact/tabview';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputWithExtra from '../../../Comman/components/InputWithExtra';
import RadioBoxDevice from '../../../Comman/components/RadioBoxDevice';
import imageCompression from 'browser-image-compression';

const url=process.env.REACT_APP_SET_URL;
const options = { 
    maxSizeMB: 0.50,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 96,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
  }

class HeartRunnerProfileComponent extends Component {
    constructor(props) {
        super(props);
        this.state={
            profileInfo:{
                FirstName:'',
                LastName:'',
                Username:'',
                EmailId:'',
                PhoneNumber:'',
                Password:'',
                ConfirmPassword:'',
                IsCoordinateBase:false,
                
            },
            statusCode:'',            
            settingInfo:{
                Status:'ONLINE',    
                IsCoordinateBase:false,
            },
            ImageInfo:{
                Image:''
            },
            StatusModeOptions:['OFFLINE','ONLINE'],

            

        }    
        this.baseState=this.state;
        this.validator = new SimpleReactValidator(
            {
              validators: {
                allowSwedish: {  // name the rule
                  message: 'The :attribute may only contains letters.',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,/^[a-zA-ZäöåÄÖÅ_ ]+$/) && params.indexOf(val) === -1
                  },
                  messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                  required: true  // optional
                }
              }
            }
          );
          this.passwordvalidator = new SimpleReactValidator(
            {
              validators: {
                allowSwedish: {  // name the rule
                  message: 'The :attribute may only contains letters.',
                  rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,/^[a-zA-ZäöåÄÖÅ_ ]+$/) && params.indexOf(val) === -1
                  },
                  messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                  required: true  // optional
                }
              }
            }
          );

          this.settingValidator=new SimpleReactValidator();
    }

    componentDidMount() {
    
        
    }
    componentWillMount() {
        ;
      //if(this.props.updateProfileInfo.statusCode!=200){
          
     // }  

        
       
    }
    componentWillUpdate(nextProps) {
        
        if (nextProps.updateProfileInfo !== this.props.updateProfileInfo) {
            console.log(nextProps)
         if(nextProps.updateProfileInfo.statusCode==200){
             
            let message=nextProps.updateProfileInfo.messageLabel==""?nextProps.updateProfileInfo.errorMessage:nextProps.updateProfileInfo.messageLabel
            this.setState({statusCode:nextProps.updateProfileInfo.statusCode})
            
            this.passwordvalidator.hideMessages();
            this.validator.hideMessages();
            this.notify(message)
            this.setState({profileInfo:{
                Password:'',
                ConfirmPassword:''           
            }})
          }
          
          this.setState(prevState => ({ profileInfo : 
            {...prevState.profileInfo,
              FirstName:  nextProps.updateProfileInfo.profileInfo.FirstName ,
              LastName:  nextProps.updateProfileInfo.profileInfo.LastName ,
              EmailId:  nextProps.updateProfileInfo.profileInfo.EmailId ,
              Username:  nextProps.updateProfileInfo.profileInfo.Username ,
              CertificateID:  nextProps.updateProfileInfo.profileInfo.CertificateID ,
             
              PhoneNumber:  nextProps.updateProfileInfo.profileInfo.PhoneNumber ,
              
             
            }
            }),)
            this.setState(prevState => ({ settingInfo : 
                {...prevState.settingInfo,
                  Status:  nextProps.updateProfileInfo.profileInfo.Status ,
                  IsCoordinateBase:nextProps.updateProfileInfo.profileInfo.IsCoordinateBase,
                  DistanceUnit:nextProps.updateProfileInfo.profileInfo.DistanceUnit,
                  Distance:nextProps.updateProfileInfo.profileInfo.Distance,
                 
                }
                }),) 
            
        }


    }
    handleInput=(e)=>{
        
       let value = e.target.value;
       let name = e.target.name;
       this.setState( prevState => ({ profileInfo : 
         {...prevState.profileInfo, [name]: value}
        }),  )
    }
    handleSettingInput=(e)=>{
        let value = e.target.value;
        let name = e.target.name;
        this.setState( prevState => ({ settingInfo : 
          {...prevState.settingInfo, [name]: value}
         }),  )
     }
    _handleImageChange=(e)=> {
        e.preventDefault();

        
        let file = e.target.files[0];
        
        if(file!=""){

                var img = new Image();
                
                img.src = window.URL.createObjectURL( file );
                img.onload = () => {
                    let width = img.naturalWidth,
                    height = img.naturalHeight;
                let error='';
                    if(!(width=='96' && height=='96') ){
                        error="Image resolution must be 96 X 96"
                    }
                    if(file.size>10000*5){
                        error="Image must be less than 50kb"
                    }
                    if(file.type!='image/png'){
                        error = "Image must be png";
                    }
                    if(error==''){
        
                        this.setState( prevState => ({
                        profileInfo : 
                        {...prevState.profileInfo,
                            Image: file,
                            
                        },
                        
                        }))
                    }
                    this.setState( prevState => ({
                        profileInfo : 
                        {...prevState.profileInfo,
                        ImageError: error,
                        },
                        
                    }))
                }        
        }
        
        
    }

    handleImageUpload=(event)=>{
        const imageFile = event.target.files[0];
        var self=this;
        if(imageFile!=""){
            let error='';
            

                imageCompression(imageFile, options)
                .then(function (compressedFile) {
                
                    self.setState({ImageInfo:{Image:compressedFile}})
                    
                })
                .catch(function (error) {
                
                });
            
        }
    }
    IsCoordinateBaseCheck = () =>{
        let IsCoordinateBase=!this.state.settingInfo.IsCoordinateBase;         
        
        this.setState( prevState => ({ settingInfo : 
                {...prevState.settingInfo, 
                    IsCoordinateBase: IsCoordinateBase,
                    DistanceUnit: '',
                    Distance:''
    
                }
        }))
    }    
    updateProfileSettings=()=>{
        if (!this.validator.allValid()) {
            
            this.validator.showMessages();
            this.forceUpdate();
        }
        else{
            let profileInfoData = this.state.profileInfo;
            profileInfoData.UserId= this.props.updateProfileInfo.UserId;
            let ImageInfo=this.state.ImageInfo;
            let ImageName=ImageInfo.Image.name;
            //profileInfoData.organizationId=this.props.adminInfo.organizationId
            //profileInfoData.OrganizationID=2061
            let phoneString=profileInfoData.PhoneNumber;
            const formData = new FormData();
            formData.append('UserId',profileInfoData.UserId)
            formData.append('FirstName',profileInfoData.FirstName)
            formData.append('LastName',profileInfoData.LastName)
           // formData.append('PhoneNumber',encodeURIComponent(phoneString))
            formData.append('PhoneNumber',phoneString)
            formData.append('Username',profileInfoData.Username)
            formData.append('EmailId',profileInfoData.EmailId)        
            formData.append('CertificateID',profileInfoData.CertificateID)
            formData.append('ImageName',ImageName)
            
               
            formData.append('Image',ImageInfo.Image)        
            this.props.updateProfileSettings(formData)
            this.validator.hideMessages();
             
        }
    }
    updateStatusSettings=()=>{
        if (!this.settingValidator.allValid()) {
            
            this.settingValidator.showMessages();
            this.forceUpdate();
        }
        else{
            let profileInfoData = this.state.settingInfo;
            profileInfoData.UserId= this.props.updateProfileInfo.UserId;
              
            this.props.updateStatusSettings(profileInfoData)
            this.settingValidator.hideMessages();
             
        }
    }
    updatePasswordSettings=()=>{
            
            if (!this.passwordvalidator.allValid()         
            ) {
                this.passwordvalidator.showMessages();
                this.forceUpdate();
            }
            else{
                  let changePasswordData={
                        'Password':this.state.profileInfo.Password,
                        'UserId':this.props.updateProfileInfo.UserId,
                    }   
                 
                 this.props.updatePasswordSettings(changePasswordData)
                 this.passwordvalidator.hideMessages();
                 
            }
    }
    handleRadio=(e)=>{
        let value = e.target.value;
        let name = e.target.name;
        
        this.setState( prevState => ({ settingInfo : 
            {...prevState.settingInfo, Status: value}
            }),  )
        }    
    notify = (message) => {
        
     /* toast("Default Notification !");*/
      this.toastId =toast.success(message, {
        position: toast.POSITION.TOP_CENTER
      });
      //this.setState(this.baseState)
      
        
      
    }

    render() {
        let orgVal = ['Select','Miles','Km','Meter'];
        let optionDistance;
        this.validator.purgeFields();
        optionDistance=orgVal.map((organizationVal,index) =>

               
               <option value={organizationVal} key={index}>{organizationVal}</option>
            );
        let imageurl=this.props.updateProfileInfo.profileInfo!=''?this.props.updateProfileInfo.profileInfo.ImageFile:''
       
        let $imagePreview = null;
        let imagePreviewUrl=url+'/'+imageurl;
        
        $imagePreview = (<img src={imagePreviewUrl} className="profileImgPrev"  alt="" />);
        
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>Profile</h2>
                </div>
                
                <ToastContainer />
                <TabView activeIndex={this.state.activeIndex} className="tabclass" onTabChange={(e) => this.setState({activeIndex: e.index})}>
                    <TabPanel header="Profile">
                        <div className="">
                               <form className="form-horizontal" >
                                    <div className="form-edit">
                                     
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">First Name</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-user" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="FirstName"
                                                                 placeholder="First Name"
                                                                 value={this.state.profileInfo.FirstName} 
                                                                 onBlur={() => this.validator.showMessageFor('FirstName')}
                                                                 onChange={this.handleInput}
                                                             />
                                                </div>
                                                 {this.validator.message('FirstName', this.state.profileInfo.FirstName, 'required|allowSwedish|min:3')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Last Name</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-user" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="LastName"
                                                                 placeholder="Last Name"
                                                                 value={this.state.profileInfo.LastName} 
                                                                 //onBlur={() => this.validator.showMessageFor('LastName')}
                                                                 onChange={this.handleInput}
                                                             />
                                                </div>
                                                 {this.validator.message('LastName', this.state.profileInfo.LastName, 'required|allowSwedish|min:3')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Phone Number</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-phone" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="PhoneNumber"
                                                                 placeholder="Phone Number"
                                                                 value={this.state.profileInfo.PhoneNumber} 
                                                                 onBlur={() => this.validator.showMessageFor('PhoneNumber')}
                                                                 onChange={this.handleInput}
                                                             />
                                                </div>
                                                 {this.validator.message('PhoneNumber', this.state.profileInfo.PhoneNumber, 'required|min:8|max:16')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Email Address</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-envelope" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="EmailId"
                                                                 placeholder="Email Address"
                                                                 value={this.state.profileInfo.EmailId} 
                                                                 onBlur={() => this.validator.showMessageFor('EmailId')}
                                                                 readOnly
                                                             />
                                                </div>
                                                 {this.validator.message('EmailId', this.state.profileInfo.EmailId, 'required|email')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Username</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-user" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="Username"
                                                                 placeholder="Username"
                                                                 value={this.state.profileInfo.Username} 
                                                                 onBlur={() => this.validator.showMessageFor('Username')}
                                                                 readOnly

                                                             />
                                                </div>
                                                 {this.validator.message('Username', this.state.profileInfo.Username, 'required')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Certificate</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-user" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="CertificateID"
                                                                 placeholder="CertificateID"
                                                                 value={this.state.profileInfo.CertificateID} 
                                                                 onBlur={() => this.validator.showMessageFor('CertificateID')}
                                                                 onChange={this.handleInput}

                                                             />
                                                </div>
                                                 {this.validator.message('CertificateID', this.state.profileInfo.CertificateID, 'required')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                            
                                                
                                                    <label className="col-md-2 control-label control-group-label">Icon
                                                    <br />
                                                    <span className="general-img">
                                                        {$imagePreview}
                                                    </span>
                                                    </label>
                                                <div className="col-md-9 ">                                    
                                                    <input type="file" onChange={this.handleImageUpload} id="profileImg" />
                                                    
                                                    <div className="srv-validation-message">
                                                        {this.state.profileInfo.ImageError}
                                                    </div>
                                                </div>
                                           
                                        </div>
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-3 col-sm-9">      
                                                <p>
                                                   <button type="button" className="btn btn-primary general-btn" onClick={() => { this.updateProfileSettings() }}>Save</button>
                                                </p>
                                            </div>
                                        </div>
                                        
                                        
                                    </div>

                                   
                                </form>
                        </div>
                    </TabPanel>
                    <TabPanel header="Settings">
                        <div className="">
                               <form className="form-horizontal" >
                                    <div className="form-edit">
                                     
                                    
                                    <RadioBoxDevice
                                        title={"Status"}
                                        name={"Status"}
                                        options={this.state.StatusModeOptions}
                                        selectedOptions = { this.state.settingInfo.Status}
                                        handleChange={this.handleRadio}
                                    />
                                    
                                            <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Recieved Alarms based on coordinates</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    
                                                    
                                                    <input
                                                        className="form-checkbox"
                                                        name="IsCoordinateBase"
                                                        id="IsCoordinateBase"
                                                        disabled={true}
                                                        defaultChecked={this.state.settingInfo.IsCoordinateBase}
                                                        type="checkbox" 
                                                        //onChange={this.IsCoordinateBaseCheck}
                                                     />
                                                </div>
                                                
                                            </div>
                                            
                                            <div className='col-md-1'></div>
                                            
                                        </div>
                                        {
                                            this.state.settingInfo.IsCoordinateBase?
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Distance from the alarm coordinate</label>
                                            <div className="col-md-6">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-user" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="text" className="form-control1" 
                                                                 name="Distance"
                                                                 placeholder="Distance"
                                                                 value={this.state.settingInfo.Distance} 
                                                                 readOnly={true}
                                                                 //onChange={this.handleSettingInput}
                                                             />
                                                </div>
                                                {this.settingValidator.message('Distance', this.state.settingInfo.Distance, 'required|numeric')}
                                            </div>
                                            
                                            <div className="col-md-4">
                                                <select id="distanceunits"  
                                                        className="form-control1" 
                                                        //onChange={this.handleSettingInput} 
                                                        value = {this.state.settingInfo.DistanceUnit}
                                                        placeholder="Select" 
                                                        ref="DistanceUnit"
                                                        name='DistanceUnit'
                                                        readOnly={true}
                                                        
                                                >
                                                   {optionDistance} 
                                                </select>
                                                
                                                    {this.settingValidator.message('DistanceUnit', this.state.settingInfo.DistanceUnit, 'required')}
                                        
                                                    
                                            </div>
                                            
                                        </div>:''
                                        }
                                        

                                        <div className="form-group"> 
                                            <div className="col-sm-offset-3 col-sm-9">      
                                                <p>
                                                <button type="button" className="btn btn-primary general-btn" onClick={() => { this.updateStatusSettings() }}>Save</button>
                                                </p>
                                            </div>
                                        </div>

                                        
                                      
                                           
                                        </div>
                                       
                                        
                                   

                                   
                                    
                                </form>
                        </div>
                    </TabPanel>
                    <TabPanel header="Change Password">
                        <div className="">
                               <form className="form-horizontal" >
                                    <div className="form-edit">
                                     
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Password</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-key" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="password" className="form-control1" 
                                                                 name="Password"
                                                                 placeholder="Password"
                                                                 value={this.state.profileInfo.Password} 
                                                                 //onBlur={() => this.passwordvalidator.showMessageFor('Password')}
                                                                 onChange={this.handleInput}
                                                             />
                                                </div>
                                                 {this.passwordvalidator.message('Password', this.state.profileInfo.Password, 'required|min:6')}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        <div className="form-group">
                                       
                                            <label className="col-md-2 control-label control-group-label">Confirm Password</label>
                                            <div className="col-md-9">
                                                <div className="input-group">                           
                                                    <span className="input-group-addon">
                                                        <i className="fa fa-key" aria-hidden="true"></i>
                                                    </span>
                                                    
                                                    <input type="password" className="form-control1" 
                                                                 name="ConfirmPassword"
                                                                 placeholder="Confirm Password"
                                                                 value={this.state.profileInfo.ConfirmPassword} 
                                                                 //onBlur={() => this.passwordvalidator.showMessageFor('ConfirmPassword')}
                                                                 onChange={this.handleInput}
                                                                 id=""
                                                             />
                                                </div>
                                                 {this.passwordvalidator.message('ConfirmPassword', this.state.profileInfo.ConfirmPassword, `required|in:${this.state.profileInfo.Password}`, {messages: {in: 'Passwords need to match!'}})}
                                            </div>
                                            <div className="col-md-1"></div>
                                        </div>
                                        
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-3 col-sm-9">      
                                                <p>
                                                   <button 
                                                    type="button" 
                                                    className="btn btn-primary general-btn" 
                                                    onClick={() => { this.updatePasswordSettings() }}
                                                    >Save</button>
                                                </p>
                                            </div>
                                        </div>
                                       
                                        
                                    </div>

                                   
                                    
                                </form>
                        </div>
                    </TabPanel>
                    
                </TabView>
        </div>
        )
    }
}

export default withRouter(HeartRunnerProfileComponent);

